import React from "react"
import parse, { attributesToProps, domToReact } from "html-react-parser"
import ImageGallery from "../ImageGallery/ImageGallery"
import Accordion from "../Accordion/Accordion"

const hasClass = (node, name) =>
  (node.attribs?.class || "").split(/\s+/).includes(name)

function findImages(nodes = []) {
  return nodes.reduce((images, node) => {
    if (node.name === "img" && node.attribs?.src) {
      const { src, srcset, sizes, alt, width, height } = node.attribs
      images.push({ src, srcSet: srcset, sizes, alt, width, height })
    } else if (node.children) {
      images.push(...findImages(node.children))
    }
    return images
  }, [])
}

export function parseContent(content) {
  if (typeof content !== "string" || !content.trim()) return null

  const options = {
    replace: node => {
      if (node.name === "div" && hasClass(node, "ig-accordion")) {
        return (
          <Accordion {...attributesToProps(node.attribs)}>
            {domToReact(node.children || [], options)}
          </Accordion>
        )
      }

      if (hasClass(node, "wp-block-gallery")) {
        // Support both the legacy ul/li gallery and modern nested image blocks.
        // Preserve unfamiliar/empty markup instead of throwing or dropping it.
        const images = findImages(node.children)
        if (!images.length) return
        const caption = (node.children || []).find(
          child => child.name === "figcaption"
        )

        return (
          <ImageGallery
            images={images}
            caption={caption ? domToReact(caption.children || []) : null}
          />
        )
      }
    },
  }

  return parse(content, options)
}
